<ng-template #template>
  <tui-preview
    [ngClass]="{cleanView: cleanView}"
    (tuiSwipe)="onSwipe($event)"
    (click)="click($event)"
    [class.isVideo]="currentImage?.videoCode"
  >
    <tui-preview-title *ngIf="title">
      {{ title }}

      @if (pictures?.length > 1) {
        / {{ index + 1 }}
      }

      <small *ngIf="currentImage?.picture && showMeta">
        / {{ currentImage.picture.sizeX }}x{{ currentImage.picture.sizeY }} / {{ currentImage.picture.type }}
      </small>
    </tui-preview-title>

    <tui-preview-pagination
      size="m"
      *ngIf="pictures.length > 1"
      [length]="pictures.length"
      (indexChange)="onIndexChange($event)"
      [(index)]="index"
    >
    </tui-preview-pagination>

    <button
      tuiIconButton
      tuiPreviewAction
      style="cursor: none"
      size="m"
      (mouseenter)="setCleanView(true)"
      (mouseleave)="setCleanView(false)"
    >
      <nb-icon icon="eye-outline"/>
    </button>
    <button
      tuiIconButton
      tuiPreviewAction
      size="m"
      iconStart="@tui.download"
      class="download"
      (click)="download()"
    ></button>
    <button
      tuiIconButton
      tuiPreviewAction
      size="m"
      *ngIf="canExpand"
      (click)="expand()"
    >
      <nb-icon icon="expand-outline"></nb-icon>
    </button>
    <button
      tuiIconButton
      tuiPreviewAction
      size="m"
      *ngIf="canCollapse"
      (click)="collapse(false)"
    >
      <nb-icon icon="collapse-outline"></nb-icon>
    </button>
    <button
      tuiPreviewAction
      tuiIconButton
      size="m"
      iconStart="@tui.x"
      (click)="close()"
    ></button>

    <div *ngIf="!currentImage.videoCode">
      <img [src]="currentImage.src" alt=""/>
    </div>

    <div *ngIf="currentImage.videoCode">
      <youtube-player class="player" [playerVars]="{autoplay: playerVars.autoplay}" [width]="playerVars.width" [height]="playerVars.height" [videoId]="currentImage.videoCode"/>
    </div>

    <div class="thumb" *ngIf="pictures?.length > 1">
      <ng-container *ngFor="let picture of pictures; let i = index">
        <span [class.selected-video]="picture.videoCode" [class.active]="i === index">
          <img [src]="picture.src" draggable="false" alt="" (click)="select(i)"/>
          <img alt="" class="video-icon" src="/assets/images/product/video.svg" *ngIf="picture.videoCode">
        </span>
      </ng-container>
    </div>

    {{ done() }}

  </tui-preview>

</ng-template>
